module.exports = __webpack_public_path__ + "img/display.c5da7933.svg";